import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { RouteComponentProps } from 'react-router-dom';

import { WorkWithTherapistRequestSent } from 'src/modules/providers/components/WorkWithTherapistRequestSent';

export const ReTriageThankYouPage: React.FC<RouteComponentProps> = () => {
    useEffect(() => {
        ReactGA.event({
            category: 'Re-triage flow',
            action: 'Visited Thank you page',
            label: 'retriage_ca_thanks_visited',
        });
    }, []);

    return <WorkWithTherapistRequestSent />;
};
